import { FC } from "react";

import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Badge } from "@fronterahealth/frontera-ui-components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@fronterahealth/frontera-ui-components/ui/tooltip";

import { ReportSectionFieldsType } from "@api/graphql/types-and-hooks";
import { AiSourcesTooltipContent } from "@components/FieldComponent/FieldComponent";
import { getFieldAiGenerated } from "@components/FieldComponent/utils";

interface ReportFieldLabelAiBadgeProps {
  field: ReportSectionFieldsType;
}

const AiBadge: FC<{ className?: string }> = ({ className }) => (
  <Badge variant="outline" size="sm" className={cn("bg-blurple-50 text-blurple-700", className)}>
    AI
  </Badge>
);

export const ReportFieldLabelAiBadge: React.FC<ReportFieldLabelAiBadgeProps> = ({ field }) => {
  const isAi = getFieldAiGenerated(field);

  if (!isAi) return null;

  if (!field.aiSources) return <AiBadge />;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          // The span gives TooltipTrigger a DOM element to attach its ref to.
          <span>
            <AiBadge className="cursor-pointer" />
          </span>
        }
      />
      <TooltipContent>
        <AiSourcesTooltipContent sources={field.aiSources} />
      </TooltipContent>
    </Tooltip>
  );
};
